import React from "react";
import {FormDefinition, FormField} from "../../lib/forms";
import fb from "../../lib/firebase";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import {
  EventoObject,
  eventoRequerProdutosUtilizados, eventoRequerProdutosVendidos, getProximoContatoLabel
} from "../../models/Evento";
import {PathDescription} from "../../models/Core";
import {
  buildModelForm, ModelForm, ModelFormField,
  ModelFormProps, onChangeCallback
} from "../../components/ModelFormHOC";
import {AppState} from "../../models/app";
import {AppDispatch, RootState} from "../../global.state";
import {connect} from "react-redux";
import {DateTime} from "luxon";
import omit from "lodash/omit";
import {AppCollection} from "../../models/Principal";
import {getCollectionFromRef} from "../../lib/utils";
import assign from "lodash/assign";
import set from "lodash/set";
import {cloneDeep} from "lodash";
import has from "lodash/has";
import ProdutoVendidoInput from "../../components/ProdutoVendido/ProdutoVendidoInput";
import {ProdutoVendido} from "../../models/Produto";
import {actions} from "../../lib/app";
import {LojaObject} from "../../models/Loja";

interface Props extends  ModelFormProps {
  app: AppState;
  dispatch: AppDispatch;
  instance?: EventoObject;
  onSubmit: () => void;
  principal: PathDescription;
}

interface State {
  loadingTipos: boolean;
  loadingLojas: boolean;
  tipos: any[];
  tipo: string | undefined;
  descricoes: string[];
  descricao: string | undefined;
  semProximoContato: boolean;
  formDef:FormDefinition;
  collection: AppCollection;
  showProdutosVendidos: boolean;
  produtosVendidos: ProdutoVendido[];
  produtosVendidosHasError: boolean;
  lojas: LojaObject[];
}

export const formDef: FormDefinition = {
  tipo: {name: 'tipo', label: 'Tipo de evento', type: "select", required: true},
  data: {name: 'data', label: 'Data', type: "date", required: true},
  descricao: {name: 'descricao', label: 'Descrição', type: "select", required: true},
  notas: {name: 'notas', label: 'Notas', type: "text", required: true},

  proximo_contato: {name: 'proximo_contato', label: 'Próximo contato', type: "date", required: true},
  sem_proximo_contato: {name: 'sem_proximo_contato', label: 'Não agendar próximo contato', type: "boolean"},
  proximo_contato_notas: {name: 'proximo_contato_notas', label: 'Notas próximo contato', type: "text", required: false},
};

export const defProdutosUtilizados: FormField = {name: 'produtos_utilizados', label: 'Produtos utilizados', type: "select-multiple", required: true};
export const defProdutosVendidosLoja: FormField = {name: 'produtos_vendidos_loja', label: 'Produtos vendidos loja', type: "searchInput", required: true};


class FormEvento extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      loadingTipos: false,
      tipos: [],
      tipo: undefined,
      descricoes: [],
      descricao: undefined,
      semProximoContato: false,
      formDef: this.getDefaultFormDef(props),
      collection: '',
      showProdutosVendidos: false,
      produtosVendidos: [],
      produtosVendidosHasError: false,
      loadingLojas: false,
      lojas: [],
    };
  }

  getDefaultFormDef(props: Props) {
    const {instance, principal} = props;

    if (instance) {
      const collection = getCollectionFromRef(instance.principal.path);
      return this.getFormDef(cloneDeep(formDef), collection, instance.tipo, instance.descricao);
    } else {
      return this.getFormDef(cloneDeep(formDef), principal.collection);
    }
  }

  /*
  Retorna o formDef ajustado conforme preenchimento atual
   */
  getFormDef(currentFormDef: FormDefinition, collection: AppCollection, tipo?: string, descricao?: string) {
    const newFormDef: FormDefinition = {...currentFormDef};
    if (eventoRequerProdutosUtilizados(collection, tipo, descricao)) {
      // adicionar produtos_utilizados
      assign(newFormDef, {
        produtos_utilizados: {...defProdutosUtilizados},
      });
    } else {
      omit(newFormDef, 'produtos_utilizados');
    }

    if (eventoRequerProdutosVendidos(collection, tipo, descricao)) {
      // adicionar produtos_vendidos_loja
      assign(newFormDef, {
        produtos_vendidos_loja: {...defProdutosVendidosLoja},
      });
    } else {
      omit(newFormDef, 'produtos_vendidos_loja');
    }

    // Ajustar labels campos
    set(newFormDef, 'proximo_contato.label',
      getProximoContatoLabel(collection, tipo, descricao, 'proximo_contato'));
    set(newFormDef, 'sem_proximo_contato.label',
      getProximoContatoLabel(collection, tipo, descricao, 'sem_proximo_contato'));
    set(newFormDef, 'proximo_contato_notas.label',
      getProximoContatoLabel(collection, tipo, descricao, 'proximo_contato_notas'));

    return newFormDef;
  }

  componentDidMount() {
    this.loadTipos();
    const {principal, instance} = this.props;

    // set semProximoContato
    if (instance) {
      const collection = getCollectionFromRef(instance.principal.path);
      if (collection === 'fazendas') {
        this.loadLojas();
      }

      const newState: any = this.setReqProximoContato(this.state, instance.sem_proximo_contato);
      newState.tipo = instance.tipo;
      newState.descricao = instance.descricao;
      newState.semProximoContato = instance.sem_proximo_contato;
      newState.collection = collection;

      // produtos vendidos
      if (eventoRequerProdutosVendidos(collection, instance.tipo, instance.descricao)) {
        newState.showProdutosVendidos = true;
        const {produtos_vendidos} = instance;
        if (instance && Array.isArray(produtos_vendidos))
          newState.produtosVendidos = produtos_vendidos;
        else
          newState.produtosVendidos = [];
      } else {
        newState.showProdutosVendidos = false;
        newState.produtosVendidos = [];
      }

      this.setState(newState);
    } else if (principal) {
      this.setState({collection: principal.collection});
      if (principal.collection === 'fazendas') {
        this.loadLojas();
      }
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    // onchange tipos
    if (this.state.tipos !== prevState.tipos) {
      let selected;
      if (this.props.instance)
        selected = this.state.tipos.find(i => i.label === this.props.instance!.tipo);

      this.setState({
        tipo: selected ? selected.label : undefined,
        descricoes: selected ? selected.descricoes : [],
      });
    }
  }

  loadTipos() {
    this.setState({loadingTipos: true}, () => {
      fb.db.collection('eventos_tipos').get()
        .then(res => {
          this.setState({loadingTipos:false, tipos: fb.col(res)});
        })
        .catch(() => this.setState({loadingTipos: false}));
    });
  }

  loadLojas() {
    this.setState({loadingLojas: true}, () => {
      fb.db.collection('lojas')
        .where('owner', '==', this.props.app.user.uid)
        .orderBy('nome')
        .get()
        .then(res => {
          this.setState({loadingLojas: false, lojas: fb.col(res)});
        })
        .catch(() => this.setState({loadingLojas: false}));
    });
  }

  setRecordProdutosUtilizados = (values: any): any[] | undefined => {
    if (!eventoRequerProdutosUtilizados(this.state.collection, values.tipo, values.descricao))
      return;

    const {produtos_utilizados} = values;
    if (produtos_utilizados) {
      return produtos_utilizados.map((id:string) => {
        const found = this.props.app.cacheData.produtos.find(i => i.id === id);
        return {
          id,
          label: found ? found.label : '-- not found --',
        }
      });
    }
  }

  onCreate = (values:any) => {
    values.principal = fb.utils.path.descriptionToRef(this.props.principal);

    // ajustar produtos_utilizados
    const produtos_utilizados = this.setRecordProdutosUtilizados(values);
    if (produtos_utilizados)
      values.produtos_utilizados = produtos_utilizados;
    else if (has(values, 'produtos_utilizados'))
      omit(values, 'produtos_utilizados');

    // ajustar produtos_vendidos
    if (this.state.showProdutosVendidos) {
      values.produtos_vendidos = this.state.produtosVendidos;
      values.produtos_vendidos_loja = fb.db.doc(`/lojas/${values.produtos_vendidos_loja}`);
    }

    return fb.document.create('eventos', values);
  };

  onUpdate = (values:any) => {
    // ajustar produtos_utilizados
    const produtos_utilizados = this.setRecordProdutosUtilizados(values);
    if (produtos_utilizados)
      values.produtos_utilizados = produtos_utilizados;
    else if (has(this.props.instance, 'produtos_utilizados'))
      values.produtos_utilizados = firebase.firestore.FieldValue.delete();

    // ajustar produtos_vendidos
    if (this.state.showProdutosVendidos) {
      values.produtos_vendidos = this.state.produtosVendidos;
      values.produtos_vendidos_loja = fb.db.doc(`/lojas/${values.produtos_vendidos_loja}`);
    } else {
      if (has(this.props.instance, 'produtos_vendidos'))
        values.produtos_vendidos = firebase.firestore.FieldValue.delete();
      if (has(this.props.instance, 'produtos_vendidos_loja'))
        values.produtos_vendidos_loja = firebase.firestore.FieldValue.delete();
    }

    return fb.document.update('eventos', this.props.instance!.id, values);
  };

  onChangeTipo: onChangeCallback = (value, formState) => {
    this.setState(state => {
      const selected = state.tipos.find(i => i.label === value);

      return {
        tipo: value,
        descricoes: selected ? selected.descricoes : [],
      };
    });
    if (value !== formState.tipo) {
      return {descricao: ''};
    }
  };

  onChangeDescricao: onChangeCallback = (value) => {
    const {principal, instance} = this.props;

    const newState: any = {
      descricao: value,
    };

    // produtos vendidos
    newState.showProdutosVendidos = eventoRequerProdutosVendidos(this.state.collection, this.state.tipo, value);

    // nada a fazer se nao temos um evento de fazendas
    if ((instance && instance.principal.path.parent.id !== 'fazendas') || (principal && principal.collection !== 'fazendas')) {
      this.setState(newState);
      return;
    }

    // Adicionar campo produtos_utilizados no form
    this.setState(state => {
      const newFormDef = this.getFormDef(state.formDef, state.collection, state.tipo, value);

      // state local
      return {
        ...newState,
        formDef: newFormDef,
      }
    });

    const setFormState: any = {}
    let formStateChanged = false;

    if (eventoRequerProdutosUtilizados(this.state.collection, this.state.tipo, value)) {
      setFormState.produtos_utilizados = [];
      formStateChanged = true;
    }
    if (eventoRequerProdutosVendidos(this.state.collection, this.state.tipo, value)) {
      setFormState.produtos_vendidos_loja = null;
      formStateChanged = true;
    }
    if (formStateChanged)
      return setFormState;
  };

  setReqProximoContato = (state: State, semProximoContato: boolean): any => {
    return {
      formDef: {
        ...state.formDef,
        proximo_contato: {
          ...state.formDef.proximo_contato,
          required: !semProximoContato,
        }
      }
    };
  }

  onChangeSemProximoContato: onChangeCallback = (value: boolean, state) => {
    const newState: any = this.setReqProximoContato(this.state, value);
    newState.semProximoContato = value;
    this.setState(newState);
    if (value && state.proximo_contato.value)
        return {proximo_contato: '', proximo_contato_notas: ''};
  }

  onValidate = (): boolean => {
    if (this.state.showProdutosVendidos && this.state.produtosVendidos.length === 0) {
      this.props.dispatch(actions.notifyError('Você precisa indicar os produtos vendidos antes de prosseguir.'));
      this.setState({produtosVendidosHasError: true});
      return false;
    }

    this.setState({produtosVendidosHasError: false});
    return true;
  }

  setProdutosVendidos = (produtosVendidos: ProdutoVendido[]) => {
    this.setState({
      produtosVendidos,
      produtosVendidosHasError: produtosVendidos.length === 0,
    });
  }

  render() {
    return (
      <ModelForm
        entityLabel="Evento"
        ownerId={this.props.app.user.uid}
        gender="m"
        formDefinition={this.state.formDef}
        onCreate={this.onCreate}
        onUpdate={this.onUpdate}
        onComplete={this.props.onSubmit}
        instance={this.props.instance}
        defaultValues={{
          data: DateTime.now().toISO(),
        }}
        onValidate={this.onValidate}
      >
        <ModelFormField
          field="data"
          max={DateTime.now().endOf('month').toFormat('yyyy-MM-dd')}
          min={DateTime.now().startOf('month').toFormat('yyyy-MM-dd')}
        />

        <ModelFormField
          field="tipo"
          options={this.state.tipos}
          optionLabel="label"
          optionValue="label"
          loading={this.state.loadingTipos}
          onChange={this.onChangeTipo}
        />
        <ModelFormField
          field="descricao"
          options={this.state.descricoes}
          disabled={!this.state.tipo}
          loading={this.state.loadingTipos}
          onChange={this.onChangeDescricao}
          interfaceOptions={{cssClass: 'app-select-alert wide'}}
        />

        {eventoRequerProdutosUtilizados(this.state.collection, this.state.tipo, this.state.descricao) &&
          <ModelFormField
            field="produtos_utilizados"
            options={this.props.app.cacheData.produtos}
            loading={!this.props.app.cacheData.produtos.length}
            optionLabel="label"
            optionValue="id"
            interfaceOptions={{cssClass: 'app-select-alert wide'}}
          />
        }

        {this.state.showProdutosVendidos &&
          <>
            <ProdutoVendidoInput
              produtos={this.props.app.cacheData.produtos}
              produtosVendidos={this.state.produtosVendidos}
              label="Produtos vendidos"
              required={true}
              setProdutosVendidos={this.setProdutosVendidos}
              hasError={this.state.produtosVendidosHasError}
            />

            <ModelFormField
              field="produtos_vendidos_loja"
              options={this.state.lojas}
              optionLabel="nome"
              optionValue="id"
              loading={this.state.loadingLojas}
              interfaceOptions="app-select-alert wide"
              getOptionLabel={(loja: LojaObject) => (
                <div>
                  <div>
                    {loja.nome}
                  </div>
                  <div className="text-xs opacity-50">
                    {loja.cidade} / {loja.estado}
                  </div>
                </div>
              )}
            />
          </>
        }

        <ModelFormField field="notas"/>
        <ModelFormField
          field="sem_proximo_contato"
          onChange={this.onChangeSemProximoContato}
        />
        <ModelFormField
          field="proximo_contato"
          max={DateTime.now().plus({years: 5}).toFormat('yyyy-MM-dd')}
          min={DateTime.now().plus({days: 1}).toFormat('yyyy-MM-dd')}
          disabled={this.state.semProximoContato}
        />
        {!this.state.semProximoContato &&
          <ModelFormField field="proximo_contato_notas"/>
        }
      </ModelForm>
    )
  }
}

const FormEventoHOC = buildModelForm(FormEvento);
export default connect(({app}: RootState) => ({app}))(FormEventoHOC);
